import { render, staticRenderFns } from "./FutureUserEvents.vue?vue&type=template&id=2830bafd&scoped=true&"
import script from "./FutureUserEvents.vue?vue&type=script&lang=js&"
export * from "./FutureUserEvents.vue?vue&type=script&lang=js&"
import style0 from "./FutureUserEvents.vue?vue&type=style&index=0&id=2830bafd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830bafd",
  null
  
)

export default component.exports